module.exports = __webpack_public_path__ + "img/unordered-list.e2999a38.svg";